import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import TablePagination from '@material-ui/core/TablePagination';
import PaginationActions from './PaginationActions';
import styled from 'styled-components';

const StyledPagination = styled(TablePagination)`
  && {
    @media (max-width: ${props => props.theme.breakpoints.values.sm - 1}px) {
      .MuiTablePagination-toolbar {
        flex-wrap: wrap;
        justify-content: center;
        padding-top: ${props => props.theme.spacing(1)}px;
        padding-right: ${props => props.theme.spacing(1)}px;
        padding-left: ${props => props.theme.spacing(1)}px;
      }
    }
  }
`;

const Pagination = ({
  getNextPageCursor,
  itemCount,
  itemsPerPage,
  itemsPerPageOptions,
  onChangePage,
  onChangeRowsPerPage,
  page,
}) => {
  const intl = useIntl();

  return (
    <StyledPagination
      component="div"
      count={itemCount}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      page={page}
      rowsPerPage={itemsPerPage}
      rowsPerPageOptions={itemsPerPageOptions}
      labelRowsPerPage={intl.formatMessage({
        id: 'dataGrid.pagination.rowsPerPage',
        defaultMessage: 'Rows per page:',
        description: 'Data grid rows per page label',
      })}
      labelDisplayedRows={({ from, to, count }) => {
        let toLabel = itemCount !== undefined ? to : to + from - 1;
        let countLabel = itemCount;

        if (toLabel < 0) {
          toLabel = 0;
        }

        if (!itemCount && count < itemsPerPage) {
          countLabel = toLabel;
        } else if (!itemCount) {
          countLabel = intl.formatMessage({
            id: 'dataGrid.pagination.many',
            defaultMessage: 'many',
            description: 'Label when the total number of rows are unknown',
          });
        }

        return intl.formatMessage(
          {
            id: 'dataGrid.pagination.displayedRows',
            defaultMessage: '{from}-{to} of {count}',
            description: 'Data grid displayed rows label',
          },
          {
            from,
            to: toLabel,
            count: countLabel,
          },
        );
      }}
      ActionsComponent={props => (
        <PaginationActions {...props} itemCount={itemCount} getNextPageCursor={getNextPageCursor} />
      )}
    />
  );
};

Pagination.propTypes = {
  getNextPageCursor: PropTypes.func,
  itemCount: PropTypes.number,
  itemsPerPage: PropTypes.number,
  itemsPerPageOptions: PropTypes.array,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  page: PropTypes.number,
};

Pagination.defaultProps = {
  getNextPageCursor: undefined,
  itemCount: undefined,
  itemsPerPage: 25,
  itemsPerPageOptions: [],
  onChangePage: undefined,
  onChangeRowsPerPage: undefined,
  page: undefined,
};

export default Pagination;
